import React from "react";
import styled from "styled-components";
import {isUnrestricted} from "./restrictions";

const RestrictionIconContainer = styled.div`
    display: flex;
    border: 2px solid #BD2D2D;
    box-sizing: border-box;
    border-radius: 4px; 
    margin-left: 12px;
    align-self: flex-start;
    margin-top: 13px;
`;

const RedBackgroundLeft = styled.div`
    background: #BD2D2D;
    width: 17.45px;
    height: 20px;
    display: flex;
    justify-content: center;
    text-align: right;
`;

const WhiteR = styled.span`
    width: 8.73px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
`;

const RedRestricted = styled.span`
    color: #BD2D2D;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    width: 66px;
    height: 17px;
    margin-left: 8px;
    margin-right: 8px;
`;

export const WideRestrictionIcon = ({idea}) => {
    if (isUnrestricted(idea)) {
        return null;
    }

    return <RestrictionIconContainer>
        <RedBackgroundLeft>
            <WhiteR>R</WhiteR>
        </RedBackgroundLeft>
        <RedRestricted>Restricted</RedRestricted>
    </RestrictionIconContainer>
};